
import { fbqMetaReducer } from '../../analytics/fbq';
import { gtmMetaReducer } from '../../analytics/gtm';
import authentication from './authentication';
import checkout from './checkout';
import countryList from './countries';
import license from './license';
import notifications from './notifications';
import player from './player';
import postAuthenticationRequests from './postAuthenticationRequests';
import preferences from './preferences';
import projects from './projects';
import staticData from './staticData';
import ui from './ui';
import user from './user';

import * as found from 'found';
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

const anyFound = found as any;

export default combineReducers<IStoreState>({
  authentication,
  checkout,
  countryList,
  gtmMetaReducer,
  fbqMetaReducer,
  form,
  found: anyFound.foundReducer,
  license,
  notifications,
  player,
  postAuthenticationRequests,
  preferences,
  projects,
  staticData,
  ui,
  user,
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/index.ts